import { Statistic } from '../components/StockTable';

// Fundamental statistics configuration (quarterly)
export const FUNDAMENTAL_STATISTICS: Statistic[] = [
  // Latest Valuation (Current Quarter)
  { key: 'pe_ratio', label: 'P/E Ratio', type: 'ratio', timeframe: 'current' },
  { key: 'forward_pe_ratio', label: 'Forward P/E Ratio', type: 'ratio', timeframe: 'current' },
  { key: 'peg_ratio', label: 'PEG Ratio', type: 'ratio', timeframe: 'current' },
  { key: 'ps_ratio', label: 'P/S Ratio', type: 'ratio', timeframe: 'current' },
  { key: 'pb_ratio', label: 'P/B Ratio', type: 'ratio', timeframe: 'current' },
  { key: 'ev_fcf_ratio', label: 'EV/FCF Ratio', type: 'ratio', timeframe: 'current' },
  { key: 'p_fcf_ratio', label: 'P/FCF Ratio', type: 'ratio', timeframe: 'current' },
  { key: 'dividend_yield', label: 'Dividend Yield', type: 'ratio', timeframe: 'current' },
  
  // Growth (Previous Quarter)
  { key: 'qoq_revenue_growth', label: 'QoQ Revenue Growth', type: 'ratio', timeframe: 'previous' },
  { key: 'qoq_net_income_growth', label: 'QoQ Net Income Growth', type: 'ratio', timeframe: 'previous' },
  { key: 'qoq_eps_growth', label: 'QoQ EPS Growth', type: 'ratio', timeframe: 'previous' },
  { key: 'yoy_revenue_growth', label: 'YoY Revenue Growth', type: 'ratio', timeframe: 'previous' },
  { key: 'yoy_net_income_growth', label: 'YoY Net Income Growth', type: 'ratio', timeframe: 'previous' },
  { key: 'yoy_eps_growth', label: 'YoY EPS Growth', type: 'ratio', timeframe: 'previous' },
  
  // Profitability (Previous Quarter)
  { key: 'revenues', label: 'Revenue', type: 'financial', timeframe: 'previous' },
  { key: 'gross_profit', label: 'Gross Profit', type: 'financial', timeframe: 'previous' },
  { key: 'operating_expense', label: 'Operating Expense', type: 'financial', timeframe: 'previous' },
  { key: 'sg_and_a', label: 'SG&A Expense', type: 'financial', timeframe: 'previous' },
  { key: 'r_and_d', label: 'R&D Expense', type: 'financial', timeframe: 'previous' },
  { key: 'operating_income_loss', label: 'Operating Income', type: 'financial', timeframe: 'previous' },
  { key: 'net_income_loss', label: 'Net Income', type: 'financial', timeframe: 'previous' },
  { key: 'diluted_earnings_per_share_adjusted', label: 'Diluted EPS', type: 'financial', timeframe: 'previous' },
  { key: 'gross_margin', label: 'Gross Margin', type: 'ratio', timeframe: 'previous' },
  { key: 'operating_margin', label: 'Operating Margin', type: 'ratio', timeframe: 'previous' },
  { key: 'net_margin', label: 'Net Margin', type: 'ratio', timeframe: 'previous' },
  { key: 'roa', label: 'ROA', type: 'ratio', timeframe: 'previous' },
  { key: 'roe', label: 'ROE', type: 'ratio', timeframe: 'previous' },
  { key: 'roic', label: 'ROIC', type: 'ratio', timeframe: 'previous' },
  
  // Balance Sheet (Previous Quarter)
  { key: 'assets', label: 'Assets', type: 'financial', timeframe: 'previous' },
  { key: 'equity', label: 'Equity', type: 'financial', timeframe: 'previous' },
  { key: 'current_assets', label: 'Current Assets', type: 'financial', timeframe: 'previous' },
  { key: 'current_liabilities', label: 'Current Liabilities', type: 'financial', timeframe: 'previous' },
  { key: 'total_debt', label: 'Total Debt', type: 'financial', timeframe: 'previous' },
  { key: 'inventory', label: 'Inventory', type: 'financial', timeframe: 'previous' },
  { key: 'book_value_per_share', label: 'Book Value Per Share', type: 'ratio', timeframe: 'previous' },
  { key: 'current_ratio', label: 'Current Ratio', type: 'ratio', timeframe: 'previous' },
  { key: 'quick_ratio', label: 'Quick Ratio', type: 'ratio', timeframe: 'previous' },
  
  // Cash Flow (Previous Quarter)
  { key: 'operating_cash_flow', label: 'Operating Cash Flow', type: 'financial', timeframe: 'previous' },
  { key: 'investing_cash_flow', label: 'Investing Cash Flow', type: 'financial', timeframe: 'previous' },
  { key: 'financing_cash_flow', label: 'Financing Cash Flow', type: 'financial', timeframe: 'previous' },
  { key: 'end_cash_position', label: 'End Cash Position', type: 'financial', timeframe: 'previous' },
  { key: 'capital_expenditure', label: 'Capital Expenditure', type: 'financial', timeframe: 'previous' },
  { key: 'free_cash_flow', label: 'Free Cash Flow', type: 'financial', timeframe: 'previous' },
  { key: 'cash_flow_margin', label: 'Cash Flow Margin (TTM)', type: 'ratio', timeframe: 'previous' },
  { key: 'ocf_ratio', label: 'Operating Cash Flow Ratio (TTM)', type: 'ratio', timeframe: 'previous' },
  { key: 'fcf_yield', label: 'Free Cash Flow Yield (TTM)', type: 'ratio', timeframe: 'previous' },
];

// Annual fundamental statistics configuration organized by category
export const ANNUAL_FUNDAMENTAL_STATISTICS: Statistic[] = [
  // End of Fiscal Year Valuation (Annual)
  { key: 'pe_ratio', label: 'P/E Ratio', type: 'ratio', timeframe: 'annual' },
  { key: 'ps_ratio', label: 'P/S Ratio', type: 'ratio', timeframe: 'annual' },
  { key: 'pb_ratio', label: 'P/B Ratio', type: 'ratio', timeframe: 'annual' },
  { key: 'ev_fcf_ratio', label: 'EV/FCF Ratio', type: 'ratio', timeframe: 'annual' },
  { key: 'p_fcf_ratio', label: 'P/FCF Ratio', type: 'ratio', timeframe: 'annual' },
  { key: 'dividend_yield', label: 'Dividend Yield', type: 'ratio', timeframe: 'annual' },
  
  // Growth (Annual)
  { key: 'yoy_revenue_growth', label: 'Revenue Growth', type: 'ratio', timeframe: 'annual' },
  { key: 'yoy_net_income_growth', label: 'Net Income Growth', type: 'ratio', timeframe: 'annual' },
  { key: 'yoy_eps_growth', label: 'EPS Growth', type: 'ratio', timeframe: 'annual' },
  
  // Profitability (Annual)
  { key: 'revenues', label: 'Revenue', type: 'financial', timeframe: 'annual' },
  { key: 'gross_profit', label: 'Gross Profit', type: 'financial', timeframe: 'annual' },
  { key: 'operating_expense', label: 'Operating Expense', type: 'financial', timeframe: 'annual' },
  { key: 'sg_and_a', label: 'SG&A Expense', type: 'financial', timeframe: 'annual' },
  { key: 'r_and_d', label: 'R&D Expense', type: 'financial', timeframe: 'annual' },
  { key: 'operating_income_loss', label: 'Operating Income', type: 'financial', timeframe: 'annual' },
  { key: 'net_income_loss', label: 'Net Income', type: 'financial', timeframe: 'annual' },
  { key: 'diluted_earnings_per_share_adjusted', label: 'Diluted EPS', type: 'financial', timeframe: 'annual' },
  { key: 'gross_margin', label: 'Gross Margin', type: 'ratio', timeframe: 'annual' },
  { key: 'operating_margin', label: 'Operating Margin', type: 'ratio', timeframe: 'annual' },
  { key: 'net_margin', label: 'Net Margin', type: 'ratio', timeframe: 'annual' },
  { key: 'roa', label: 'ROA', type: 'ratio', timeframe: 'annual' },
  { key: 'roe', label: 'ROE', type: 'ratio', timeframe: 'annual' },
  { key: 'roic', label: 'ROIC', type: 'ratio', timeframe: 'annual' },
  
  // Balance Sheet (Annual)
  { key: 'assets', label: 'Assets', type: 'financial', timeframe: 'annual' },
  { key: 'equity', label: 'Equity', type: 'financial', timeframe: 'annual' },
  { key: 'current_assets', label: 'Current Assets', type: 'financial', timeframe: 'annual' },
  { key: 'current_liabilities', label: 'Current Liabilities', type: 'financial', timeframe: 'annual' },
  { key: 'total_debt', label: 'Total Debt', type: 'financial', timeframe: 'annual' },
  { key: 'inventory', label: 'Inventory', type: 'financial', timeframe: 'annual' },
  { key: 'book_value_per_share', label: 'Book Value Per Share', type: 'ratio', timeframe: 'annual' },
  { key: 'current_ratio', label: 'Current Ratio', type: 'ratio', timeframe: 'annual' },
  { key: 'quick_ratio', label: 'Quick Ratio', type: 'ratio', timeframe: 'annual' },
  
  // Cash Flow (Annual)
  { key: 'operating_cash_flow', label: 'Operating Cash Flow', type: 'financial', timeframe: 'annual' },
  { key: 'investing_cash_flow', label: 'Investing Cash Flow', type: 'financial', timeframe: 'annual' },
  { key: 'financing_cash_flow', label: 'Financing Cash Flow', type: 'financial', timeframe: 'annual' },
  { key: 'end_cash_position', label: 'End Cash Position', type: 'financial', timeframe: 'annual' },
  { key: 'capital_expenditure', label: 'Capital Expenditure', type: 'financial', timeframe: 'annual' },
  { key: 'free_cash_flow', label: 'Free Cash Flow', type: 'financial', timeframe: 'annual' },
  { key: 'cash_flow_margin', label: 'Cash Flow Margin (TTM)', type: 'ratio', timeframe: 'annual' },
  { key: 'ocf_ratio', label: 'Operating Cash Flow Ratio (TTM)', type: 'ratio', timeframe: 'annual' },
  { key: 'fcf_yield', label: 'Free Cash Flow Yield (TTM)', type: 'ratio', timeframe: 'annual' },
];

// Category headers for organizing statistics (quarterly)
export const FUNDAMENTAL_CATEGORY_HEADERS = [
  { startIndex: 0, label: 'Latest Valuation' },
  { startIndex: 8, label: 'Growth' },
  { startIndex: 14, label: 'Profitability' },
  { startIndex: 28, label: 'Balance Sheet' },
  { startIndex: 37, label: 'Cash Flow' },
];

// Annual category headers for organizing statistics
export const ANNUAL_FUNDAMENTAL_CATEGORY_HEADERS = [
  { startIndex: 0, label: 'Year-End Valuation' },
  { startIndex: 6, label: 'Growth' },
  { startIndex: 9, label: 'Profitability' },
  { startIndex: 23, label: 'Balance Sheet' },
  { startIndex: 32, label: 'Cash Flow' },
];

